import { render, staticRenderFns } from "./RilevazioniComponent.vue?vue&type=template&id=05db7ff2&"
import script from "./RilevazioniComponent.vue?vue&type=script&lang=js&"
export * from "./RilevazioniComponent.vue?vue&type=script&lang=js&"
import style0 from "./RilevazioniComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports